import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  
  footer: {
    width: '100%',
    padding: '1rem',
    height: '9rem',
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    color: '#822659',
    fontSize: '9px'
  },

}))